import { compose } from 'rambda';
import { useDispatch } from 'react-redux';
import { BreadcrumbsAliasModel, IPlainObject } from '../../../models';
import {
  BreadcrumbsActionType,
  removeBreadcrumbAlias,
  setBreadcrumbAlias,
} from './breadcrumbsReducer.actions';

export interface BreadcrumbsAliasesModel {
  breadcrumbsAliases: BreadcrumbsAliasModel[];
}

const initialState: BreadcrumbsAliasesModel = {
  breadcrumbsAliases: [],
};

export function breadcrumbsReducer(
  state: BreadcrumbsAliasesModel = initialState,
  action: IPlainObject,
): BreadcrumbsAliasesModel {
  switch (action.type) {
    case BreadcrumbsActionType.setAlias:
      return {
        ...state,
        breadcrumbsAliases: [
          ...state.breadcrumbsAliases,
          {
            key: action.key,
            label: action.label,
          },
        ],
      };
    case BreadcrumbsActionType.removeAlias:
      return {
        ...state,
        breadcrumbsAliases: state.breadcrumbsAliases.filter(
          (alias: BreadcrumbsAliasModel): boolean => alias.key !== action.key,
        ),
      };
    default:
      return state;
  }
}

export function useBreadcrumbsReducer(): IPlainObject {
  const dispatch = useDispatch();

  return {
    setBreadcrumbAlias: compose(dispatch, setBreadcrumbAlias),
    removeBreadcrumbAlias: compose(dispatch, removeBreadcrumbAlias),
  };
}

export function selectBreadcrumbsAliases() {
  return (state: {
    breadcrumbsReducer: BreadcrumbsAliasesModel;
  }): BreadcrumbsAliasModel[] => state.breadcrumbsReducer.breadcrumbsAliases;
}
